import { parse } from "date-fns";
import { useTranslation } from "react-i18next";
import * as Yup from "yup";

export function GenerateProfitSchema() {
  const { t } = useTranslation();

  const validation = Yup.object().shape({
    start_date: Yup.date()
      .transform(function (value, originalValue) {
        if (this.isType(value)) {
          return value;
        }
        const result = parse(originalValue, "dd/MM/yyyy", new Date());
        return result;
      })
      .typeError(t("LABEL.invalid date"))
      .required(t("LABEL.select a date")),
    end_date: Yup.date()
      .transform(function (value, originalValue) {
        if (this.isType(value)) {
          return value;
        }
        const result = parse(originalValue, "dd/MM/yyyy", new Date());
        return result;
      })
      .typeError(t("LABEL.invalid date"))
      .required(t("LABEL.select a date")),
  });

  return validation;
}
